var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRizevoIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_145_9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.99991 28L30.9993 28C31.1729 28.0001 31.3436 27.955 31.4946 27.8692C31.6455 27.7833 31.7714 27.6596 31.86 27.5102C31.9486 27.3609 31.9968 27.191 31.9998 27.0174C32.0029 26.8438 31.9606 26.6724 31.8773 26.52L26.1374 16.0003L31.8773 5.48051C31.9606 5.32818 32.0029 5.15676 31.9998 4.98314C31.9968 4.80951 31.9486 4.63967 31.86 4.49032C31.7714 4.34097 31.6455 4.21727 31.4946 4.13139C31.3436 4.04552 31.1729 4.00042 30.9993 4.00055L3.99991 4.00055C2.93907 4.00055 1.92167 4.42197 1.17155 5.1721C0.421417 5.92222 -9.20579e-07 6.93962 -8.74208e-07 8.00046L-1.74842e-07 24.0001C-1.28471e-07 25.0609 0.421418 26.0783 1.17155 26.8285C1.92167 27.5786 2.93907 28 3.99991 28V28Z",
    fill: "#1F1F1F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_145_9"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRizevoIcon);
export default __webpack_public_path__ + "static/media/rizevoIcon.e834a2c5e5ccf13866047f987a849744.svg";
export { ForwardRef as ReactComponent };